function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104.000000, -374.000000)",
  className: "primary-fill"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.000000, 255.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M67.7894191,7.15036593 C67.6617518,7.05409401 67.4885124,7 67.3078629,7 C67.1272135,7 66.9539741,7.05409401 66.8263068,7.15036593 L63.199624,10.6328311 C63.0718146,10.728996 63,10.8594878 63,10.9955612 C63,11.1316346 63.0718146,11.2621264 63.199624,11.3582913 L66.8263068,14.8407564 C66.9968178,14.9757014 67.2510905,15.030357 67.4904697,14.9835173 C67.729849,14.9366776 67.9166589,14.7957148 67.9784193,14.6153209 C68.0401797,14.434927 67.9671701,14.2434942 67.7877175,14.1152963 L64.6425909,10.9955612 L67.7877175,7.8758261 C67.9157528,7.77983142 67.9878736,7.64943513 67.9881928,7.51336168 C67.9885119,7.37728823 67.9170033,7.24670079 67.7894191,7.15036593 Z",
  id: "ic_arrow",
  transform: "translate(65.500000, 11.000000) rotate(180.000000) translate(-65.500000, -11.000000) "
}))))));

const SvgIcMenuArrow = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "8px",
    viewBox: "0 0 5 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMenuArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-menu-arrow.7dcd8623.svg";
export { ForwardRef as ReactComponent };